var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.12471 8.61103C1.024 8.61055 0.925775 8.57973 0.842841 8.5226C0.759908 8.46547 0.696116 8.38467 0.659786 8.29074C0.623457 8.19681 0.616276 8.09412 0.639181 7.99605C0.662085 7.89798 0.714011 7.80909 0.788187 7.74097L4.50643 4.36275L0.788187 0.980031C0.737312 0.936491 0.6957 0.883177 0.665821 0.82325C0.635941 0.763324 0.618403 0.698006 0.614246 0.631173C0.610089 0.56434 0.619397 0.497352 0.64162 0.434185C0.663843 0.371017 0.698527 0.312957 0.743614 0.263448C0.788701 0.21394 0.843273 0.173991 0.904092 0.145973C0.964911 0.117955 1.03074 0.102438 1.09767 0.100343C1.1646 0.0982473 1.23127 0.109616 1.29372 0.133776C1.35617 0.157935 1.41313 0.194392 1.46123 0.240983L5.586 3.99323C5.63748 4.04009 5.67861 4.09719 5.70675 4.16086C5.73489 4.22453 5.74943 4.29338 5.74943 4.363C5.74943 4.43262 5.73489 4.50147 5.70675 4.56514C5.67861 4.62881 5.63748 4.68591 5.586 4.73277L1.46123 8.48102C1.36472 8.56802 1.24472 8.61103 1.12471 8.61103Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowWhite);
export default __webpack_public_path__ + "static/media/rightArrow_white.657ac4f568ee156c5403df12e4416e47.svg";
export { ForwardRef as ReactComponent };